import {clear_cart, update_basket_counter} from './_cart';

document.addEventListener("DOMContentLoaded", function() {

	//if this is the checkout/confirmation page
	if(document.body.classList.contains('page-template-page-checkout')) {

		//check for the existance of the summary
		let order_success = document.getElementById('order-success-summary');

		//if we have a summary
		if(order_success) {

			//empty the cart
			clear_cart();

			//update the counter
			update_basket_counter();
		}
	}
}); 